import styled, { css } from "styled-components";
import { Form, Radio, Row, Modal, Select, Checkbox } from "antd";
import FormItem from "antd/lib/form/FormItem";
import {
  GhostButtonComponent,
  UnderlineLink,
  PillButton,
  PrimaryButtonComponent,
  DisplayFlex,
  ContentContainer,
  StepFlexRow,
  ErrorMessage
} from "../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.primary};
`;

const fontCommonStyle = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
`;

const cursorPointer = css`
  cursor: pointer;
`;


export const Err = styled(ErrorMessage).attrs(props => ({
  className: "error-fields-ooa"
}))`
  margin-top: 5px;
  line-height: 1.25;
  letter-spacing: 0.6px;
`;

export const FormItemWrapper = styled(FormItem)`
  .ant-form-item-label {
    margin-bottom: 10px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding: 0px;
    }
  }
  .ant-form-item-label > label::after {
    margin: 0px;
  }
`;

export const PagesHeadingWrapper = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h1};
  line-height: 1.14;
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: 15px;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    line-height: 1.2;
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 2.75rem 9% 0 9%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 2.75rem 6.4% 0 6.1%;
  }
`;

export const SubHeading = styled.div`
  ${fontCommonStyle}
  line-height: 1.5;
  max-width: 980px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const TabsContent = styled.div`
  line-height: 50px;
  padding: 0 20px;
  cursor: default;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 13px;
  }
`;

export const TooltipTextwrap = styled.span`
  font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-align: center;
  display: flex;
  width: 170px;
  padding: 5px 5px;
`;

export const StepFlexRowMargin = styled(StepFlexRow)`
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 30px;

    .ant-col-lg-4 {
      margin-bottom: 20px;
    }
  }
`;

export const FormContainer = styled(Form)`
  &&& {
    margin-top: ${props => props.theme.spacing.margins.YBetween};
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
      line-height: 0;
    }
  }
`;

export const RadioButtonWrapper = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
`;

export const LabelWrapper = styled.div`
  ${fontCommonStyle}
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: 1.5;
  font-size: ${props => props.theme.fontSize.primary};
  margin-bottom: 4px;
  margin-top: 50px;
  content: none;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.primary};
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
`;

export const PhoneLabelWrap = styled(LabelWrapper)`
  margin-top: 24px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
`;

export const LabelWrapperDelivery = styled(PhoneLabelWrap)`
  margin-top: 34px;
`;

export const MainWrapper = styled.div`
  .ant-form-item-label {
    label::after {
      content: none;
    }
  }
`;

export const RadioWrapper = styled.div`
  .ant-radio-inner {
    border-color: #b6bdbd;
  }
  .ant-radio-inner::after {
    background-color: #006778;
  }
`;
export const PrimaryElement = styled.span`
  display: inline-block;
  margin-top: 2px;
  color: #505050;
`;
export const MailContentWrapper = styled.div`
  .ant-radio-wrapper {
    font-size: 16px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }
  ${fontCommonStyle}
  line-height: 1.5;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .ant-radio-inner {
    top: 3px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      top: 0px;
    }
    border-color: #b6bdbd;
  }
  .ant-radio-inner::after {
    background-color: #006778;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
    font-weight: normal;
    margin-right: 14px;
  }
`;

export const MailContentWrapperfirst = styled(MailContentWrapper)`
  .ant-radio-wrapper {
    display: flex;
    align-items: flex-start;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: 0px;
  font-family: HelveticaNeue !important;
  ${styles}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
    font-size: 14px;
    margin-left: 26px;
  }
`;

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: 14px;
  height: 30px !important;
  background-color: #f5f5f5;
  margin: 16px 20px 16px 0;
  &:hover,
  &:focus {
    color: #006778;
    background: #f5f5f5;
    border-color: #d9d9d9;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 16px;
    margin-top: 0;
  }
`;

export const PillButtonAddressWrap = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 16px;
  }
`;

const buttonCommon = css`
  //font-family: HelveticaNeue-CondensedBlack !important;
  font-size: 18px !important;
  line-height: 1.67 !important;
  letter-spacing: 1.1px !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;

export const GhostButton = styled(GhostButtonComponent)`
  ${buttonCommon}
  color: ${props => props.theme.fontColors.primary};
  margin: 26px 30px -5px 0;
  letter-spacing: ${props => props.theme.letterSpacing.normal} !important;
  font-size: ${props => props.theme.fontSize.primary} !important;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 15px 10px 0;
    flex-basis: 50%;
  }
`;

export const GhostButtonReset = styled(GhostButton)`
  font-size: ${props => props.theme.fontSize.primary} !important;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 10px 0;
    flex-basis: 50%;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${props => !props.marginTop ? '0px' : '26px'};
  margin-right: ${props => !props.marginRight ? '0px' : '30px'};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
    margin-top: 0;
    margin-right: ${props => !props.marginRight ? '0px' : '15px'};
    margin-bottom: 10px;
  }
`;

export const PrimaryButtonComponentNext = styled(PrimaryButtonComponent)`
  ${buttonCommon}
  text-align: center;
  margin-top: ${props => !props.marginTop ? '0px' : '26px'};
  border-radius: 0;
  border: none;
  letter-spacing: ${props => props.theme.letterSpacing.normal} !important;
  font-size: ${props => props.theme.fontSize.primary} !important;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100% !important;
    margin-top: 0;
  }
`;

export const MarginTopButtonWrapper = styled(ButtonWrapper)`
  margin-top: ${props => props.marginValue ? '16px' : '0px'};
`;

export const PrimaryButtonComponentDisabled = styled(
  PrimaryButtonComponentNext
)`
  font-size: ${props => props.theme.fontSize.primary} !important;
  background-color: rgba(0, 103, 120, 0.3) !important;
  color: ${props => props.theme.fontColors.white} !important;
`;

export const DisplayFlexSpace = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const DisplayFlexSpaceMobile = styled(DisplayFlexSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 16px;
  }
`;

export const SelectTabsWrapper = styled.div`
  .ant-tabs-bar {
    margin: 0;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;
    border-bottom: 1px solid #d4d4d4;

    .ant-tabs-nav {
      /* border-left: 1px solid #bfbfbf;
      border-right: 1px solid #bfbfbf; */
    }

    .ant-tabs-nav-container {
      height: 55px !important;
    }
  }
  .ant-tabs-tab {
    color: #505050;
  }
  .ant-tabs-tab:hover {
    color: #505050;
  }

  .ant-tabs.ant-tabs-card {
    .ant-tabs-card-bar {
      .ant-tabs-tab {
        margin-right: 0;
        border: none;
        padding-left: 0;
        padding-right: 0;
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        height: 56px;
        border-bottom: 1px solid #d4d4d4;
        border-left: 1px solid #d4d4d4;
      }

      .ant-tabs-tab-active {
        border-left: 1px solid #d4d4d4;
        border-right: 1px solid #d4d4d4;
        color: #006778;
        border-top: none;
        border-top: 4px solid #006778 !important;
        height: 56px;
        border-bottom: none;
      }
    }
  }

  .ant-tabs-tab {
    font-family: HelveticaNeue-Bold;
    font-size: 16px;
    color: #505050;
    letter-spacing: 0.6px;
    text-align: center;
    background-color: #ffffff !important;
    border-radius: 0 !important;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
      letter-spacing: 0.5px;
    }
  }
`;

export const SelectOptionGenderWrapper = styled.div`
  .ant-select-selection {
    .ant-select-arrow {
      i {
        display: block;
      }
    }
  }

  .ant-select-arrow {
    color: ${props => props.theme.fontColors.textColor};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.border.pill};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const SelectOptionMainWrapper = styled.div`
  .ant-select-dropdown {
    /* border: 1px solid #d4d4d4; */
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
      border: none;
      background-color: #ffffff;
      padding: 5px 20px;
    }
    li:hover {
      color: #167f91;
      background-color: #e6f7ff;
    }
  }

  .ant-select-dropdown:after {
    bottom: 0;
  }
`;

export const SelectOptionWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 2.15;
  padding: 2px 0;
  font-weight: normal;
`;

const titleCommmon = css`
  ${fontCommonStyle}
  line-height: 1.5;
  letter-spacing: 0px;
  font-weight: normal;
`;
export const TitleWrapper = styled.div`
  ${titleCommmon}
  // margin-bottom: 10px;
  /* margin-top: 6px; */
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const TitleWrapperAddress = styled.div`
  ${titleCommmon}
  margin-bottom: 0px;
  /* margin-top: 6px; */
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const TitleWrapperTitle = styled(TitleWrapper)`
  padding-bottom: 0px;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
  }
`;

export const ExtraContentWrapper = styled.div`
  ${titleCommmon}
  padding-top: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
`;

export const MiddleName = styled.div`
  color: #505050;
  font-size: 16px;
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: ${ props => props.height ? props.height: '40px !important' };
  }
  
  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }

  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.fontColors.thead};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 ${props => props.paddingHorizontal ? '12px': '20px'};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding: 0 ${props => props.paddingHorizontal ? props.paddingHorizontal: '20px'};
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;

export const SelectWrapperGraded = styled(InputWrapper)`
  .ant-select-selection {
    background: #f2f2f2 !important;
    border: 1px solid #d4d4d4;
  }

  .ant-select-arrow-icon {
    display: block;
  }

  .ant-input {
    border: 1px solid #d4d4d4;
    font-size: 16px;
  }

  .ant-select-selection-selected-value {
    color: ${props => props.theme.colors.tabHead};
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
`;
export const InputWrapperGraded = styled(InputWrapper)`
  input,
  .ant-select-selection--single {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    background-color: ${props => props.theme.backgroundColor.cardDark} !important;
  }

  input {
    padding: 0 20px;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection-selected-value {
    font-family:  ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.colors.tabHead};
    font-size: ${props => props.theme.fontSize.primary};
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
  .ant-input-suffix {
    display: none;
  }
  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const SecurityNumWrap = styled.div`
  input {
    height: 45px;
  }
  .ant-input {
    border-radius: 0;
    font-size: ${props => props.theme.fontSize.primary};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }

  .ant-input-suffix {
    display: none;
  }
`;

export const SpanWrap = styled.span`
  color: ${props => props.theme.colors.tabHead} !important;
  white-space: pre-wrap;
  span {
    display: inline-block;
    vertical-align: top;
  }
`;

export const TextWrap = styled.span`
  color: ${props => props.theme.colors.tabHead} !important;
`;

export const TitleWrapperPrimary = styled.div`
  margin-top: 31px;
  height: 70px;
  margin-left: 6px;
  ${titleCommmon};
  display: flex;
  align-items: center;
  .ant-radio-wrapper {
    margin-right: 20px;
  }
  .ant-radio-wrapper,
  a {
    margin-top: 0px;
    font-size: 16px;
    font-weight: normal;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: 0;
      font-size: 14px;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    height: 14px;
    margin-bottom: 40px;
  }
`;

export const NoResultsWrap = styled.div`
  margin-left: 11px;
`;

export const InputWrapperDrop = styled.div`
  .ant-select-selection--single {
    height: 40px !important;
  }
  .ant-select-selection--single:focus {
    border: 1px solid #505050 !important;
    outline-color: #505050 !important;
    outline-width: 1px !important;
  }
  .ant-select-selection-selected-value,
  .ant-select-search__field {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    line-height: 38px;
    vertical-align: middle;
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.textColor};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
      align-items: center;
      height: 100%;
    }
    div {
      font-size: ${props => props.theme.fontSize.primary};
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
      }
    }
  }

  .ant-select-selection__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.border};
    padding: 0 9px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }
  .ant-select-selection {
    border-radius: 0;
    border: 1px solid #d4d4d4;
  }

  .ant-select-selection {
    box-shadow: none;
  }

  .ant-select-selection__rendered {
    height: 100%;
    padding: 0 9px;
  }

  .ant-select-arrow {
    color: ${props => props.theme.fontColors.textColor};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${props => props.theme.border.pill};
    background: ${props => props.theme.backgroundColor.pill};
  }
`;

export const WebTitle = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.17;
  color: ${props => props.theme.fontColors.headingColor};
  padding: 0 20px 0 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 0 0 5px 5px;
    font-size: ${props => props.theme.fontSize.h5}
  }
`;

export const NoChange = styled.div`
  ${fontCommonStyle};
  line-height: 1.13;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 7px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const NoChangeSpace = styled(NoChange)`
  margin-bottom: 45px;
  width: 172px;
  display: flex;
  justify-content: space-between;
  margin-top: -3.25rem;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: 0;
  }
`;

export const WebAccessHeaderWrapper = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 78px;
  }
`;

export const Align = styled.span`
  display: flex;
  align-items: center;
`;

export const AlignContent = styled.span`
  display: flex;
  align-items: center;
  .ant-checkbox-wrapper {
    margin-bottom: 9px !important;
  }
`;

export const DisplayFlexAlign = styled(DisplayFlex)`
  align-items: center;
  .ant-radio-wrapper {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    margin-right: 15px;
    align-items: initial;
  }
`;

export const DisplayFlexSpaceWidth = styled(DisplayFlexSpace)`
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    align-items: center;
  }
`;

export const WebAccessInfoWrapper = styled.div`
  .ant-collapse-item {
    background: #ffffff;
    border-bottom: none;
  }

  .ant-collapse-content {
    border-radius: 0 !important;
    .ant-collapse-content-box {
      padding: 0 32px 6px;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0 20px 6px;
      }
    }
  }

  .ant-collapse-content {
    border-top: none;
  }

  .ant-collapse {
    border-radius: 0;
    border-bottom: 1px solid #d9d9d9;
  }

  margin-bottom: 50px;
  margin-top: 16px;
`;

export const ExpandWrap = styled.div`
  margin: 5px 14px 0 0;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 4px 0 0;
  }
`;

export const AdvisoryFormWrapper = styled.div`
  .ant-form {
    margin-top: 20px !important;
  }
`;

export const RowWrapper = styled(Row)`
  /* margin-top: 6px; */
`;
export const CheckboxEmail = styled(Checkbox)`
  &&& .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${props => props.theme.colors.white};
    border-color: ${props => props.theme.colors.primaryColor};
    &::after {
      border: 2px solid ${props => props.theme.colors.primaryColor} !important;
      border-left: 0 !important;
      border-top: 0 !important;
    }
  }
`;
export const FlexWrap = styled.div`
  display: flex;
  align-items: baseline;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: block;
  }
`;

export const EmailWrapper = styled.div`
  .ant-checkbox-wrapper {
    margin-top: 2px;
    .ant-checkbox-inner {
      width: 15px;
      height: 15px;
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: #006778;
        border-color: #006778;
      }
    }
  }
`;
export const EmailTitleWrapper = styled(TitleWrapper)`
  margin-right: 20px;
`;

export const CheckWrap = styled.span`
  ${fontCommonStyle}
  font-size: 12px;
  line-height: 1.5;
  font-weight: normal;
`;

export const IconWrap = styled.div`
  float: right;
  ${cursorPointer};
  margin-top: 23px;
  margin-right: -50px;
  i {
    font-size: ${props => props.theme.fontSize.h5};
    color: ${props => props.theme.colors.lightblack};
  }

  @media only screen and (min-width: 320px) and (max-width: 1024px) {
    margin-right: 0;
  }
`;

export const InfoWrapperDiv = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0;
`;
export const InfoContentWrapper = styled.div`
  padding: 0 6% 0 6%;
  position: fixed;
  background: ${props => props.theme.backgroundColor.layoutLight};
  width: 77%;
  height: 88%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 594px;
    width: 87.5%;
  }
`;

export const InfoWrapper = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
`;

export const PopHeader = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.headingColor}
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height:${props => props.theme.lineHeight.secondary};
  text-align: center;
  border-bottom: 2px solid #bfbfbf;
  padding: 30px 0 14px 0;
  @media only screen and (max-width: 768px) {
    line-height: 1.8rem;
  }
`;

export const QASectionWrapper = styled.div`
  margin: 15px 0 9px 0;
  margin-bottom: 24px;
  &&.electronicDeliveryContentWrapper {
    padding-right: 6px;
  }
`;

export const QASectionWrapperLast = styled(QASectionWrapper)`
  margin-bottom: 9px;
`;
export const QuestionWrap = styled.div`
  ${fontCommonStyle};
  font-family: HelveticaNeue-Bold;
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const QASection = styled.div`
  height: calc(100% - (180px));
  overflow: scroll;
  overflow-x: ${props => props.scrollView ? 'hidden' : 'scroll'};
  @media only screen and (max-width: 320px) {
    height: 61%;
  }
  @media only screen and (min-width: 321px) and (max-width: 375px) {
    height: 63%;
  }
  @media only screen and (min-width: 376px) and (max-width: 382px) {
    height: calc(100% - (225px));
  }
  @media only screen and (min-width: 383px) and (max-width: 768px) {
    height: calc(100% - (195px));
  }
`;

export const AnswerWrap = styled.div`
  ${fontCommonStyle};
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const PrimaryButtonOkay = styled(PrimaryButtonComponent)`
  width: 150px !important;
  border-radius: 0;
  font-size: ${props => props.theme.fontSize.heading};
  line-height:${props => props.theme.lineHeight.h1};
  letter-spacing: ${props => props.theme.letterSpacing.buttonText};
  ${cursorPointer}
  margin-top: 31px ;
  border: none;
  @media only screen and (max-width: 767px) {
    margin-top: 0px;
    position: absolute;
    bottom: 20px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    margin-top: 22px;
  }
  @media only screen and (min-width: 411px) and (max-width: 731px) {
    margin-top: 51px;
  }
  @media only screen and (min-width: 1024px) and (max-width: 1366px) {
    margin-top: 31px;
  }
`;

export const DisplayFlexOkay = styled(DisplayFlex)`
  justify-content: center;
  border-top: ${props => props.border ? '2px solid #bfbfbf': 'none'}
`;

export const TitleMarginTop = styled.div`
  margin-top: 16px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 16px;
  }
`;

export const TitleMarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const DeliveryMarginBottom = styled.div`
  margin-bottom: 20px;
`;

export const AddressWrap = styled.div`
  margin-bottom: -10px;
`;

export const AdvisorMargin = styled.div`
  margin-bottom: 34px;
`;

export const SelectdropwownStyles = styled.div`
  .ant-select {
    color: ${props => props.theme.fontColors.textColor} !important;
  }
  .ant-select-dropdown {
    top: 40px !important;
    width: 100% !important;
  }
  .ant-select-selection-selected-value{
    color: ${props => props.theme.fontColors.textColor} !important;
  }
`;

export const SecuritySelector = styled(Select)`
  .ant-select-selection {
    overflow: hidden;
  }
`;
//Added visibility: hidden for .ant-btn:first-child to hide the Close button below Continue button
export const AlertPopUpPrimary = styled(Modal)`
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.thead};
    text-align: center;
  }
  .ant-modal-header {
    padding-top: 30px;
    border: none;
    border-radius: 0;
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.thead};
    text-align: center;
    font-size: ${props => props.theme.fontSize.primary};
    font-weight:400 !important;
    padding:5px 50px;
  }
  @media only screen and (max-width:768px){
    .ant-modal-header {
      padding-top: 20px !important;
    }
    .ant-modal-body {
      font-size: ${props => props.theme.fontSize.secondary};
      padding:5px 20px;
    } 
    .ant-modal-footer > div > .ant-btn-primary {
      width: 100% !important;
      font-size: ${props => props.theme.fontSize.primary};
      letter-spacing: 0.5px;
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    width: 150px;
    border-radius: 0;
    letter-spacing: 0.5px; /* Changed font fixes - Abhishek */
    height: 50px;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.backgroundColor.primaryColor};
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: ${props => props.theme.colors.white};
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.67;
    color: ${props => props.theme.backgroundColor.primaryColor};
    text-decoration: underline;
    visibility: hidden;
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.backgroundColor.primaryColor};
    display:none;
    text-decoration: underline;
  }
`;


export const NonGradedWrapperSSN = styled.div`
  margin-bottom: 5px;
`;
export const ElectronicMailerInfoContentWrapper = styled.div`
  padding: 0 6% 0 6%;
  position: fixed;
  background: ${props => props.theme.backgroundColor.layoutLight};
  width: 77%;
  height: 88%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  @media only screen and (min-width: 768px) {
    max-width: 1105px;
    max-height: 614px;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    height: 594px;
    width: 87.5%;
  }
  @media only screen and (max-width: 320px) {
    height: 574px;
  }
  @media only screen and (min-width: 991px) {
    padding: 0px 91px 0px 91px !important;
  }
`;
export const ElectronicDeliveryIconWrap = styled.div`
  float: right;
  position: absolute;
  ${cursorPointer};
   i {
    font-size: ${props => props.theme.fontSize.h5};
    color: ${props => props.theme.colors.lightblack};
  }
  @media only screen and (max-width: 767px) {
    top: 15px;
    right: 10px;
  }
  @media only screen and (min-width: 768px) {
    top: 23px;
    right: 23px;
  }
`;